import styled from 'styled-components';
export const Sticky = styled.div `
    position: sticky;
    bottom: 1rem;
    z-index: 1;
`;
